import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useExploreImage } from "../ExploreImageContext";
import { ImageCanvas } from "./ImageCanvas";
import { RegionListPanel } from "./RegionListPanel";
import { SelectGuidelines } from "./SelectGuidelines";
import { useImageRegions } from "./useImageRegions";

export const RegionSelectionView = () => {
  const { t } = useTranslation();
  const { state, confirmRegions, discard } = useExploreImage();
  const { regions, updateRegion, removeRegion, addRegion, resetRegions } =
    useImageRegions();

  const { uploadedImage } = state;
  if (!uploadedImage) return null;

  return (
    <Box
      sx={{
        backgroundColor: "var(--alias-background-white, #fff)",
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 150px)",
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "var(--spacing16, 16px)",
          padding: "var(--spacing16, 16px) var(--spacing24, 24px)",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "var(--title-t1-20-medium-size, 20px)",
              color: "var(--alias-text-on-white-primary, #1a1a1a)",
            }}
          >
            {t("ldp_explore_image_region_title")}
          </Typography>
        </Box>

        <Button
          onClick={discard}
          startIcon={<CloseIcon sx={{ fontSize: "16px !important" }} />}
          sx={{
            flexShrink: 0,
            textTransform: "none",
            fontSize: "var(--body-b3-12-regular-size, 12px)",
            color: "var(--alias-text-on-white-disable, #999999)",
          }}
        >
          {t("ldp_explore_image_region_discard")}
        </Button>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          padding: "var(--spacing24, 24px)",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: "var(--spacing20, 20px)",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "var(--spacing10, 10px)",
          }}
        >
          <ImageCanvas
            imageSrc={uploadedImage}
            regions={regions}
            onUpdateRegion={updateRegion}
            onRemoveRegion={removeRegion}
            onAddRegion={addRegion}
          />
          <SelectGuidelines />
        </Box>

        <Box
          sx={{
            width: { xs: "100%", md: 280, lg: 320 },
            flexShrink: 0,
          }}
        >
          <RegionListPanel
            regions={regions}
            imageSrc={uploadedImage}
            onReset={resetRegions}
            onBack={discard}
            onConfirm={confirmRegions}
          />
        </Box>
      </Box>
    </Box>
  );
};
